import { isEmpty, mapValues, pick, trim } from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from 'tss-react/mui';
import { isValidPhone } from '../../Lib/Utils/FormUtils/vendor-application';
import validateEmail from '../../Lib/Utils/Helpers/validate-email';
import TextInput from '../ReusableComponents/TextInput/TextInput';

const useStyles = makeStyles()(() => ({
  row: {
    alignItems: 'center',
    display: 'flex',
  },
}));

export default function CompanyFields(props) {
  const { classes } = useStyles();
  const [form, setForm] = useState(pick(props.form, ['phone', 'email']));
  const [errors, setErrors] = useState(mapValues(form, () => false));

  const validator = {
    phone: (value) => isValidPhone(value, isEmpty(value)),
    email: (value) => isEmpty(value) || !validateEmail(value),
  };

  function onChange(e) {
    const { name, value } = e.target;
    if (validator[name](value) === false) {
      setErrors((err) => ({ ...err, [name]: false }));
      props.onErrorUpdate(name, null);
    } else {
      props.onErrorUpdate(name, 'error');
      setErrors((err) => ({
        ...err,
        phone: false,
      }));
    }
    setForm((f) => ({ ...f, [name]: value }));
    props.onChange(name, trim(value));
  }

  return (
    <div className={classes.row}>
      <TextInput
        fullWidth
        required
        error={errors.phone}
        disabled={props.disabled}
        label="Phone Number"
        variant="outlined"
        onChange={(e) => {
          onChange(e);
        }}
        name="phone"
        value={form.phone || ''}
        id="va-phone"
        autoComplete="no"
      />
      <TextInput
        fullWidth
        required
        disabled={props.disabled}
        label="Email"
        variant="outlined"
        error={errors.email}
        onChange={(e) => {
          onChange(e);
        }}
        name="email"
        value={form.email || ''}
        id="va-email"
        autoComplete="no"
      />
    </div>
  );
}

CompanyFields.propTypes = {
  disabled: PropTypes.bool.isRequired,
  form: PropTypes.shape({}).isRequired,
  onErrorUpdate: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};
